import {
  TableBodyStyled,
  TableCellStyled,
  TableContainerStyled,
  TableHeadStyled,
  TableRowStyled,
  TableStyled,
  Span
} from 'components'
import { ITurnOverTable } from 'services/NGT/EffectiveConsolidation'
import { COLORS } from 'utils'

import { FormatTableData as FormatTData } from '../../ultils/FormatTableData'
import { CollapsibleTable } from '../CollapsibleTable/CollapsibleTable'

interface IReportTable {
  tableData: ITurnOverTable
  titleHeader: string
  isGeneratePDF: boolean
}

export const ReportTable = ({
  tableData,
  titleHeader,
  isGeneratePDF
}: IReportTable) => {
  FormatTData.formatarTableData(tableData)
  FormatTData.formatarSubItens(tableData)
  return (
    <>
      <TableContainerStyled>
        <TableStyled>
          <TableHeadStyled>
            <TableRowStyled backgroundColor={COLORS.blueFonts}>
              <TableCellStyled
                align="center"
                textColor={COLORS.white}
                colSpan={2}
              >
                {titleHeader}
              </TableCellStyled>
              <TableCellStyled
                align="center"
                textColor={COLORS.white}
                colSpan={9}
              >
                TURNOVER
              </TableCellStyled>
            </TableRowStyled>
            <TableRowStyled>
              <TableCellStyled colSpan={2} />
              <TableCellStyled align="center">Ativo</TableCellStyled>
              <TableCellStyled align="center">Demitido</TableCellStyled>
              <TableCellStyled align="center">Acesso</TableCellStyled>
              <TableCellStyled align="center">Transferido</TableCellStyled>
              <TableCellStyled align="center">Afastado</TableCellStyled>
              <TableCellStyled align="center">Compartilhado</TableCellStyled>
              <TableCellStyled align="center">Total</TableCellStyled>
              <TableCellStyled align="center">Sem Demitidos</TableCellStyled>
              <TableCellStyled align="center">% TurnOver</TableCellStyled>
            </TableRowStyled>
          </TableHeadStyled>
          <TableBodyStyled>
            {tableData?.itensConsolidacao.length > 0 &&
              tableData?.itensConsolidacao.map((row, index) => (
                <CollapsibleTable
                  key={index}
                  row={row}
                  isGeneratePDF={isGeneratePDF}
                />
              ))}

            <TableRowStyled backgroundColor={COLORS.tableColor}>
              <TableCellStyled colSpan={2}>
                <Span text="TOTAL:" fontWeight="bold" />
              </TableCellStyled>
              <TableCellStyled align="center">
                {FormatTData.formatarNumero(tableData?.total?.ativo)}
              </TableCellStyled>
              <TableCellStyled align="center">
                {FormatTData.formatarNumero(tableData?.total?.demitido)}
              </TableCellStyled>
              <TableCellStyled align="center">
                {FormatTData.formatarNumero(tableData?.total?.acesso)}
              </TableCellStyled>
              <TableCellStyled align="center">
                {FormatTData.formatarNumero(tableData?.total?.transferido)}
              </TableCellStyled>
              <TableCellStyled align="center">
                {FormatTData.formatarNumero(tableData?.total?.afastado)}
              </TableCellStyled>
              <TableCellStyled align="center">
                {FormatTData.formatarNumero(tableData?.total?.compartilhado)}
              </TableCellStyled>
              <TableCellStyled align="center">
                {FormatTData.formatarNumero(tableData?.total?.totalEfetivo)}
              </TableCellStyled>
              <TableCellStyled align="center">
                {FormatTData.formatarNumero(tableData?.total?.qtTotalSemDemitido)}
              </TableCellStyled>
              <TableCellStyled align="center">
                {FormatTData.formatarNumero(tableData?.total?.turnOver)}%
              </TableCellStyled>
            </TableRowStyled>
          </TableBodyStyled>
        </TableStyled>
      </TableContainerStyled>
    </>
  )
}
